import { localstorageGet } from '@/helpers/helper';
import axios from 'axios';
import { clearSession, getSession } from '@/indexedDB';

const APP_BASE_URL = 'https://base-auction.com/api';

const axiosBaseClient = axios.create();
axiosBaseClient.interceptors.request.use(
  async (config: any) => {
    config.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
    config.baseURL = APP_BASE_URL;
    return config;
  },
  (error: any) => {
    Promise.reject(error);
  }
);

export default axiosBaseClient;
